(() => {
  if (customElements.get('blankabric-print-coupon')) return;

  class PrintCoupon extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.card = this.closest('[data-bb-product-card]');
      this.select = this.querySelector('select');
      if (!this.card || !this.select) return;
      this.select.addEventListener('change', () => {
        this.update();
        this.card.dispatchEvent(new CustomEvent('bb:select-coupon', { detail: { id: this.select.value } }));
      }, { signal: this.abort.signal });
      this.card.addEventListener('bb:coupon-change', (event) => {
        if (![...this.select.options].some(option => option.value === String(event.detail.id))) return;
        this.select.value = String(event.detail.id);
        this.update();
      }, { signal: this.abort.signal });
      this.update();
    }

    disconnectedCallback() { this.abort?.abort(); }

    update() {
      const option = this.select.selectedOptions[0];
      if (!option || option.disabled) return;
      const fields = { '.bb-product-card__price': option.dataset.price, '.bb-product-card__length': option.dataset.length, '[data-print-meter]': option.dataset.meter };
      for (const [selector, value] of Object.entries(fields)) {
        const node = this.card.querySelector(selector);
        if (node) { node.textContent = value || ''; node.hidden = !value; }
      }
      let compare = this.card.querySelector('.bb-product-card__compare-price');
      if (!compare && option.dataset.compare) {
        compare = document.createElement('s');
        compare.className = 'bb-product-card__compare-price';
        if (this.dataset.compareLabel) compare.setAttribute('aria-label', this.dataset.compareLabel);
        this.card.querySelector('.bb-product-card__price-link')?.prepend(compare);
      }
      if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
      this.card.querySelectorAll('.bb-product-card__title, .bb-product-card__price-link, .bb-product-card__media a').forEach(link => {
        const url = new URL(link.href, location.origin);
        url.searchParams.set('variant', option.value);
        link.href = url.toString();
      });
      const wishlist = this.card.querySelector('[data-bb-wishlist-toggle]');
      if (wishlist) {
        wishlist.dataset.productPrice = `${option.dataset.price} ${option.dataset.length}`.trim();
        wishlist.dataset.productUrl = this.card.querySelector('.bb-product-card__price-link')?.getAttribute('href') || wishlist.dataset.productUrl;
      }
    }
  }

  customElements.define('blankabric-print-coupon', PrintCoupon);
})();
